{
	"success": "Sucesso!",
	"error": "Erro!",
	"warning": "Atenção!"
}
